/**
 * Builds a minimal HTML document for in-app bill preview / browser print.
 */
export function buildBillPrintHtml(order, orderId) {
    if (!order) return '';
    const id = (orderId ?? order._id ?? '').toString();
    const shortId = id.slice(-6);
    const subTotal =
        Number(order.totalAmount) ||
        (order.items?.reduce((s, i) => s + (Number(i.price) || 0) * (Number(i.quantity) || 0), 0) ?? 0);
    const tax = Number(order.taxAmount) || 0;
    const service = Number(order.serviceAmount) || 0;
    const discount = Number(order.offerDiscount) || 0;
    const total =
        Number(order.finalAmount) || subTotal + tax + service - discount;
    const dateStr = order.orderDate ? new Date(order.orderDate).toLocaleString() : '';
    const itemsHtml = (order.items || [])
        .map(
            (item) =>
                `<tr><td>${escapeHtml(item.name)}</td><td>${item.quantity || 0}</td><td>₹${(Number(item.price) || 0).toFixed(2)}</td><td class="right">₹${((Number(item.price) || 0) * (Number(item.quantity) || 0)).toFixed(2)}</td></tr>`
        )
        .join('');

    return `<!DOCTYPE html><html><head><meta charset="utf-8"/><meta name="viewport" content="width=device-width, initial-scale=1"/><title>Bill #${escapeHtml(shortId)}</title>
<style>
body{font-family:system-ui,sans-serif;margin:0 auto;max-width:420px;color:#111;-webkit-text-size-adjust:100%;padding:16px;padding-top:max(16px, env(safe-area-inset-top, 0px));padding-right:max(16px, env(safe-area-inset-right, 0px));padding-bottom:max(16px, env(safe-area-inset-bottom, 0px));padding-left:max(16px, env(safe-area-inset-left, 0px))}
table{width:100%;border-collapse:collapse;margin:12px 0}
th,td{padding:8px;text-align:left;border-bottom:1px solid #eee}
th{background:#f5f5f5;font-weight:600}
.right{text-align:right}
.meta{color:#666;font-size:0.9rem;margin-bottom:4px}
.total{font-size:1.1rem;font-weight:bold;margin-top:12px;color:#15803d}
h1{font-size:1.25rem;margin-bottom:8px}
</style></head><body>
<h1>Bill</h1>
<div class="meta">Order #${escapeHtml(shortId)}</div>
<div class="meta">${escapeHtml(order.customerName || 'Guest')} | ${escapeHtml(order.mobileNumber || '-')}</div>
<div class="meta">${escapeHtml(dateStr)}</div>
<table><thead><tr><th>Item</th><th>Qty</th><th>Price</th><th class="right">Amount</th></tr></thead><tbody>${itemsHtml}</tbody></table>
<div class="right">Subtotal: ₹${subTotal.toFixed(2)}</div>
${tax > 0 ? `<div class="right">Tax: ₹${tax.toFixed(2)}</div>` : ''}
${service > 0 ? `<div class="right">Service: ₹${service.toFixed(2)}</div>` : ''}
${discount > 0 ? `<div class="right">Discount: −₹${discount.toFixed(2)}</div>` : ''}
<div class="right total">Total: ₹${total.toFixed(2)}</div>
</body></html>`;
}

function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

